import React from 'react';

type FieldSetContextProps = {
  status?: string | null;
  statusId?: string | null;
};

export const FieldSetContext = React.createContext<FieldSetContextProps>({
  status: null,
  statusId: null,
});
